import { Component } from '@angular/core';

@Component({
  selector: 'app-purchase-icon',
  templateUrl: './purchase-icon.component.html',
})
export class PurchaseIconComponent {

}
